// extracted by mini-css-extract-plugin
export default {"root":"BjIO31","headline":"hjep6J"};